export default __webpack_public_path__ + "static/media/art-and-design.27885450.svg";